import { createContext, useContext } from "react"

export type DrawerSide = "left" | "right"

export type DrawerContextValue = {
  /** Which edge the drawer enters from once it presents as a side panel */
  side: DrawerSide
  /** Whether the drawer presents as a side panel rather than a bottom sheet */
  isSidePanel: boolean
}

const DrawerContext = createContext<DrawerContextValue | null>(null)

export const DrawerProvider = DrawerContext.Provider

export function useDrawerContext(): DrawerContextValue {
  const context = useContext(DrawerContext)

  if (!context) {
    throw new Error("Drawer subcomponents must be rendered inside <Drawer>")
  }

  return context
}
